import styled from 'styled-components'

import {
  TypeStyleHeadlineExtraSmall,
  TypeStyleHeadlineMicro,
  fromMd,
} from '@syconium/little-miss-figgy'

export const Intro = styled.div`
  display: none;

  ${fromMd} {
    display: flex;
    flex-direction: column;
    gap: ${o => o.theme.spacing(2)};
    text-align: center;
  }
`

export const Title = styled(TypeStyleHeadlineExtraSmall)`
  text-transform: capitalize;
  text-align: center;
`

export const SubTitle = styled(TypeStyleHeadlineMicro)`
  text-align: center;
  font-weight: 400;
  text-transform: none;
  font-size: 14px;
  margin-top: ${o => o.theme.spacing(2)};
`
